module.exports = __webpack_public_path__ + "static/img/A1.6ff53b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/A1.png
// module id = oLUi
// module chunks = 1